import { useEffect, useState } from "react";
/**
 * True from the first time `open` is true: mount a lazy overlay on first use
 * and keep it mounted afterwards (closing animation, kept state).
 */
export function useMountedOnce(open) {
    const [used, setUsed] = useState(false);
    useEffect(() => {
        if (open)
            setUsed(true);
    }, [open]);
    return used || open;
}
